import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrainPersonnelComponent } from './train-personnel.component';
import { ClickToCallComponent } from './click-to-call/click-to-call.component';
import { PersonRoleIconComponent } from './person-role-icon/person-role-icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { QmPipesModule } from '../../../components/qm-pipes/qm-pipes.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeIconsModule } from '~app/fontawesome-icons.module';



@NgModule({
  declarations: [ TrainPersonnelComponent, ClickToCallComponent, PersonRoleIconComponent ],
  imports: [
    CommonModule,
    QmPipesModule,
    TranslateModule,
    FontAwesomeIconsModule,
    NgbTooltipModule
  ],
  exports: [ TrainPersonnelComponent, ClickToCallComponent, PersonRoleIconComponent ]
})
export class TrainPersonnelModule { }
